module.exports = __webpack_public_path__ + "static/media/tree.4868cc6c.png";